import React, {useState} from 'react';
import { withStyles } from "@mui/styles";
import {Dialog, DialogContent, DialogTitle, IconButton, Typography} from '@mui/material';
import {connect} from "trim-redux";
import {useTranslation} from "react-i18next";
import {Close} from "@mui/icons-material";
import {Styles} from "../../../../config/design/styles";
import Button from "@mui/material/Button";
import {showExactDate} from "../../../../config/values";
import {ChevronRight, Circle, CircleCheck,CircleX} from "lucide-react";
import Grid from "@mui/material/Grid2";
import LoadingButton from "../../../components/elements/LoadingButton";
import axios from "axios";
import {defaultVariables} from "../../../../config";
import {useNavigate} from "react-router-dom";

function ChangeOrderStatusAcceptDeliveryButton({order,role,classes,reload }) {
    const { t } = useTranslation();
    const [open,setOpen] = useState(false);
    const [orderStatus,setOrderStatus] = useState("on_way");
    const [submitLoading, setSubmitLoading] = useState(false);
    const navigation = useNavigate();

    const handleRequest = async () => {
        setSubmitLoading(true);
        const data = new FormData();
        data.append('order_id', order.id);
        data.append('order_status', orderStatus);

        const loginToken = localStorage.getItem('ACT');
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };

        try {
            const response = await axios.post(`${defaultVariables.url}/orders/change-status-accept-delivery`, data, config);
            setSubmitLoading(false);
            reload();
            setOpen(false);
            if(orderStatus === "canceled"){
                navigation(-1);
            }
        } catch (error) {
            console.error(error.response);
            setSubmitLoading(false);

        }
    }
    return (
        <>
            <Button
                className={classes.buttonAlert}
                onClick={() => setOpen(true)}
                endIcon={<ChevronRight/>}
                color="primary"
                variant="contained"
            >
                {t('confirmRejectOrder')}
            </Button>
            <Dialog  open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
                <DialogTitle className="dialog-title">
                    {t('confirmRejectOrder')}
                    <IconButton
                        onClick={() => setOpen(false)}
                        style={{position:"absolute",right:15,top:15}}
                        size="small"
                    >
                        <Close className="lucide-icon"/>
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item size={12}>
                            <Typography className="text-center bg-gray-box">{t('preparationTimeIs')} <strong>{showExactDate(order.order_time,order.shop.preparation_time)}</strong></Typography>
                        </Grid>
                        <Grid item size={12} className="flex-direction flex-justify-center flex-column-md">
                            <Button
                                onClick={() => setOrderStatus('on_way')}
                                size="large"
                                startIcon={orderStatus === "on_way" ? <CircleCheck/> : <Circle/>}
                                variant={"outlined"}
                                color={orderStatus === "on_way" ? 'secondary' : "default"}
                            >
                                {t('confirmOrder')}
                            </Button>
                            <Button
                                onClick={() => setOrderStatus('canceled')}
                                variant={"outlined"}
                                size="large"
                                startIcon={orderStatus === "canceled" ? <CircleX/> : <Circle/>}
                                color={orderStatus === "canceled" ? 'primary' : "default"}
                            >
                                {t('rejectOrder')}
                            </Button>
                        </Grid>
                            {
                                orderStatus === "on_way" &&
                                <>
                                    <Grid item size={12}>
                                        <Typography color="secondary" >{t('confirmOrderDescMakng')}</Typography>
                                    </Grid>
                                </>
                            }
                        {
                            orderStatus === "canceled" &&
                            <>
                                <Grid item size={12}>
                                    <Typography color="primary" className="mb-10">{t('rejectOrderDescMaking')}</Typography>
                                    <Typography color="primary">{t('rejectOrderDescMaking2')}</Typography>
                                </Grid>
                            </>
                        }
                        <Grid item size={12}>
                            <LoadingButton
                                className="confirm-btn"
                                variant="contained"
                                color={orderStatus === "canceled" ? 'primary' : "secondary"}
                                onClick={() => handleRequest()}
                                loading={submitLoading}
                            >
                                {orderStatus === "on_way" ? t("confirm") : t("reject")}
                            </LoadingButton>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
        </>

    );
}
const mapStateToProps = (state) => ({
    isAuth: state.isAuth,
});

export default withStyles(Styles)(connect(mapStateToProps)(ChangeOrderStatusAcceptDeliveryButton));
